@if (showMainRoute()) {
  <h1>My Profile</h1>
  <div>{{ authSvc.authentication().user.FirstName }} {{ authSvc.authentication().user.LastName }}</div>
  <a href="mailto://{{ authSvc.authentication().user.Email }}">{{ authSvc.authentication().user.Email }}</a>
  <br />
  {{ authSvc.authentication().user.PhoneNumber }}

  <div class="action-buttons">
    <a [routerLink]="[routesConst.edit]" mat-raised-button class="link-btn-default">Edit my Profile</a>
    <a [routerLink]="[routesConst.changePassword]" mat-raised-button class="link-btn-default">Change my Password</a>
  </div>
}
